module.exports = __webpack_public_path__ + "static/media/conrado.839fcda3.jpg";